import React, { useEffect, useState } from 'react';
import './HumanAvailableModal.css';

export interface HumanAvailableModalProps {
  isOpen: boolean;
  username: string;
  onAccept: () => void;
  onDecline: () => void;
  busy?: boolean;
}

const HumanAvailableModal: React.FC<HumanAvailableModalProps> = ({
  isOpen,
  username,
  onAccept,
  onDecline,
  busy = false,
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const t = setTimeout(() => setVisible(true), 10);
      return () => clearTimeout(t);
    }
    setVisible(false);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className={`human-avail-overlay ${visible ? 'visible' : ''}`}
        onClick={onDecline}
        role="presentation"
      />
      <div
        className={`human-avail-modal ${visible ? 'visible' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="human-avail-title"
      >
        <h2 id="human-avail-title" className="human-avail-title">
          Someone is available
        </h2>
        <p className="human-avail-body">
          <strong>{username}</strong> is online and free to play.
        </p>
        <p className="human-avail-note">
          If you accept, we&apos;ll send them a game challenge. If you&apos;re in a bot game, accepting will end that game.
        </p>
        <div className="human-avail-actions">
          <button
            type="button"
            className="human-avail-btn human-avail-btn-decline"
            onClick={onDecline}
            disabled={busy}
          >
            Not now
          </button>
          <button
            type="button"
            className="human-avail-btn human-avail-btn-accept"
            onClick={onAccept}
            disabled={busy}
          >
            {busy ? '…' : 'Challenge'}
          </button>
        </div>
      </div>
    </>
  );
};

export default HumanAvailableModal;
